module.exports = __webpack_public_path__ + "static/media/unevenshoulder_normal.cba62515.png";